<template>
  <div class="col-xs-12">

        <spinner size="large" v-if="flagSessionsDataIsLoading"></spinner>
        <div v-else class="col-xs-12">
                
            <div class="input-daterange form-group row">
                <div class="input-date-time-picker" >

                    <div class="col-sm-12 col-md-6">
                        <div class="col-sm-12 col-md-12" align="left">
                            <div class="col-md-6 col-sm-12">
                                <label for="startDateTime">{{ labelStartDate[actualLanguage] }}</label>
                                <date-picker
                                    class="el-input__inner form-control"
                                    v-model="myStartDate"
                                    type="date"
                                    placeholder=""
                                    clear-icon=""
                                    format="yyyy-MM-dd"
                                    value-format="timestamp"
                                />
                            </div>
                            <div class="col-md-6 col-sm-12">
                                <label for="startDateTime">{{ labelStartTime[actualLanguage] }}</label>
                                <time-select
                                    v-model="startTime"
                                    placeholder=""
                                    clear-icon=""
                                    :picker-options="{
                                        start: '00:00',
                                        step: '01:00',
                                        end: '24:00'
                                    }"
                                />
                            </div>
                        </div>

                        <div class="col-md-12 col-sm-12" align="left">
                            <div class="col-md-6 col-sm-12">
                                <label for="startDateTime">{{ labelEndDate[actualLanguage] }}</label>
                                <date-picker
                                    class="el-input__inner form-control"
                                    v-model="myEndDate"
                                    type="date"
                                    placeholder=""
                                    clear-icon=""
                                    format="yyyy-MM-dd"
                                    value-format="timestamp"
                                />
                            </div>
                            <div class="col-md-6 col-sm-12">
                                <label for="startDateTime">{{ labelEndTime[actualLanguage] }}</label>
                                <time-select
                                    v-model="endTime"
                                    placeholder=""
                                    clear-icon=""
                                    :picker-options="{
                                        start: '00:00',
                                        step: '01:00',
                                        end: '24:00'
                                    }"
                                />
                            </div>
                        </div>
                    </div>


                    <div class="col-md-6 col-xs-12" align="center">


                      <div class="col-xs-12 push">
                        <button type="button" @click="refreshGraph()" class="btn btn-success" name="button"><spinner size="small" v-if="flagGraphDataIsLoading"></spinner>
                        <span v-else><i class="fa fa-repeat pull-left"></i>{{ labelButtonRefresh[actualLanguage] }}</span></button>
                      </div>

                    <div class="col-xs-12 push">
                        <select @change="setSessionsChartData" v-model="selectedDataType" class="js-select2">
                            <option value="kwh">{{ labelSelectorEnergy[actualLanguage] }}</option>
                            <option value="cost">{{ labelSelectorCost[actualLanguage] }}</option>
                            <option value="duration">{{ labelSelectorDuration[actualLanguage] }}</option>
                        </select>
                    </div>

                  </div>


                </div>
            </div>


            <div v-if="flagDisplayGraph" class="form-group" style="height:400px">
                <div class="col-sm-12">
                    <div class="block-content block-content-full bg-gray-lighter text-center">
                        <bar-chart :chartData="channelSessionsGraphData" ></bar-chart>
                    </div>
                </div>
            </div>


            <div v-if="true" class="col-xs-12 col-sm-12 align-center">
                <download-csv class = "btn btn-default" :data = "sessionsData" name = "ChannelSessionsData.csv"><i class="fa fa-download fa-1x push-5-r "></i>{{labelButtonDownloadData[actualLanguage]}}</download-csv>
            </div>
        </div>
  </div>

</template>

<script>

import _ from 'underscore'
import {mapState, mapGetters, mapActions} from 'vuex'
import Spinner from '../../../components/Spinner.vue'
import LineChart from '@/components/LineChart'
import BarChart from '@/components/BarChart.js'

import Vue from 'vue'
import JsonCSV from 'vue-json-csv'
Vue.component('downloadCsv', JsonCSV)


import { DatePicker, TimePicker, TimeSelect } from 'element-ui';
import moment from 'moment';

export default {
  props: ['channel_id'],
  data() {
    return {
        timeRange : 0,
        actualLanguage : "FR",
        flagSessionsDataIsLoading:false,

        flagDisplayGraph:false,
        flagGraphDataIsLoading : false,
        sessionsData : [],
        channelSessionsGraphData: null,

        selectedDataType:'kwh',
        labelSelectorEnergy:{FR: "Énergie (kW/h)", EN: 'Energy (kW/h)'},
        labelSelectorCost:{FR: "Coût ($)", EN: 'Cost ($)'},
        labelSelectorDuration:{FR: "Durée (Hr)", EN: 'Duration (Hr)'},

        myStartDate: '',
        myEndDate: '',
        startTime: '00:00',
        endTime: '00:00',
        myStartDateTime : this.startDate,
        myEndDateTime : this.endDate,
        dataSamplingSelect : 'Automatic',

        labelStartDate: {FR: 'Date de début', EN: 'Start date'},
        labelStartTime: {FR: 'Heure de début', EN: 'Start time'},

        labelEndDate: {FR: 'Date de fin', EN: 'End date'},
        labelEndTime: {FR: 'Heure de fin', EN: 'End time'},

        labelButtonRefresh: {FR: 'Rafraichir', EN: 'Refresh'},
        labelButtonDownloadData: {FR: 'Télécharger les données', EN: 'Download data'},


    }
  },

  components: {
    LineChart,
    BarChart,
    Spinner,
    DatePicker,
    TimePicker,
    TimeSelect,
  },

  computed: {
    ...mapState('sessionStore', ['profileData','displayAdminFlag','actualBundle']),
    ...mapState('chargesStore',['startDate', 'endDate']),
  },

  methods: {

    refreshGraph(){

        this.myStartDateTime = this.formatTimeToUnix(this.myStartDate, this.startTime)
        this.myEndDateTime = this.formatTimeToUnix(this.myEndDate, this.endTime)
        this.getSessionsData()
        this.$store.dispatch('chargesStore/setStartDate', this.myStartDateTime)
        this.$store.dispatch('chargesStore/setEndDate', this.myEndDateTime)
        },

    setSessionsChartData() {
        this.flagDisplayGraph = false

        let time = []
        let y1   = []
        let y2   = []
        let actualLabel = ''
        for (let session of this.sessionsData) {
            //const labelX = `${session.startTime.split(' ')[2]} - ${session.endTime.split(' ')[2]}`;
            const labelX = `${session.startTime} - ${session.endTime.split(' ')[2]}`;
            time.push(labelX)

            if(this.selectedDataType=='kwh'){
                y1.push(session.energy_kwh)
                actualLabel = this.labelSelectorEnergy[this.actualLanguage]
                }            
            if(this.selectedDataType=='cost'){
                y1.push(session.cost)
                actualLabel = this.labelSelectorCost[this.actualLanguage]
                }
             if(this.selectedDataType=='duration'){
                y1.push(session.duration_min)
                actualLabel = this.labelSelectorDuration[this.actualLanguage]
                }
 

        }

        this.channelSessionsGraphData = {
            labels: time,
            datasets: [{
            // bezierCurve: false,
            label: actualLabel,
            backgroundColor: 'rgba(70, 195, 123, 0.8)',
            borderColor: 'rgba(5, 210, 92, .25)',
            pointBackgroundColor: 'rgba(68, 180, 166, 1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
            data: y1 }]

            }

        this.$nextTick(() => {
          this.flagDisplayGraph = true
        });

    },





   getSessionsData(){
        this.flagGraphDataIsLoading = true
        var requestData = { 'postAction':'GetChannelSessions',
                            'bundleId':this.actualBundle.bundle_id,
                            'channelId':this.channel_id,
                            //'channelId':'CHN::BDL::GRP::marc-at-evsens-dot-ca::DefaultGroup::DefaultBundle::D65V',
                            'start':this.myStartDateTime,
                            'end':this.myEndDateTime,
                            }

        this.$store.dispatch('sessionStore/postChannel', requestData)
            .then((response) => {
            if(response.data.Code=='OK'){
                console.log(response.data)
                this.sessionsData = response.data.ChannelSessions
                this.setSessionsChartData()
                this.flagGraphDataIsLoading = false
                }
                else{
                    //console.log(response.data) 
                    window.alert(response.data.PromptMessage[this.actualLanguage])
                    this.flagGraphDataIsLoading = false
                    }
            }) 
      },


    formatTimeToUnix(date, time) {
        const unixTime = moment(date)
        .set('hour', time.split(':')[0])
        .set('minute', time.split(':')[1])
        .set('seconds', 0)
        .unix()

        return unixTime
    },

  },
  mounted() {

    this.timeRange = this.endDate - this.startDate

    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}

    this.myStartDate = new Date(this.startDate * 1000),
    this.myEndDate = new Date(this.endDate * 1000)

    var DateStringSplit = this.myStartDate.toString().split(':')
    this.startTime = DateStringSplit[0].substring(DateStringSplit[0].length-2,DateStringSplit[0].length)+':'+DateStringSplit[1]

    DateStringSplit = this.myEndDate.toString().split(':')
    this.endTime = DateStringSplit[0].substring(DateStringSplit[0].length-2,DateStringSplit[0].length)+':'+DateStringSplit[1]
    

    this.myStartDateTime = this.formatTimeToUnix(this.myStartDate, this.startTime)
    this.myEndDateTime = this.formatTimeToUnix(this.myEndDate, this.endTime)

    this.getSessionsData()
    this.flagSessionsDataIsLoading = false
    //this.getMovingAverageLogData()


  }
}
</script>

<style lang="css">

</style>



// WEBPACK FOOTER //
// SessionsGraph.vue?ee11bda2